var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationTelexPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7913 9.07335C30.3683 9.07335 31.6466 10.3517 31.6466 11.9287H32.4558C32.4558 9.90486 30.8151 8.26422 28.7913 8.26422H26.1349C25.6135 8.26422 25.1909 7.84158 25.1909 7.32024V4.66381C25.1909 2.63997 23.5502 0.999325 21.5264 0.999325H21.0029V1.80845H21.5264C23.1034 1.80845 24.3817 3.08683 24.3817 4.66381V7.32024C24.3817 8.28845 25.1666 9.07335 26.1349 9.07335H28.7913Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0954 26.5954C18.0954 26.8189 18.2766 27 18.5 27H30.7028C31.6711 27 32.4559 26.2153 32.4559 25.2469V11.0742C32.4559 9.42741 31.8016 7.84757 30.6372 6.68314L26.7728 2.81874C25.6084 1.65432 24.0285 1 22.3817 1H12.7531C11.7847 1 11 1.78475 11 2.75311V10.3438C11 10.5672 11.1811 10.7483 11.4046 10.7483C11.628 10.7483 11.8091 10.5672 11.8091 10.3438V2.75311C11.8091 2.2316 12.2316 1.80913 12.7531 1.80913H22.3817C23.814 1.80913 25.188 2.37822 26.2007 3.39089L30.0651 7.25528C31.0777 8.26795 31.6468 9.64197 31.6468 11.0742V25.2469C31.6468 25.7684 31.2243 26.1909 30.7028 26.1909H18.5C18.2766 26.1909 18.0954 26.372 18.0954 26.5954Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 14.405C19 14.6284 19.1391 14.8096 19.3107 14.8096H27.6873C27.859 14.8096 27.9981 14.6284 27.9981 14.405C27.9981 14.1816 27.859 14.0004 27.6873 14.0004H19.3107C19.1391 14.0004 19 14.1816 19 14.405Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19.4587C19 19.6822 19.1122 19.8633 19.2506 19.8633H27.7493C27.8877 19.8633 27.9999 19.6822 27.9999 19.4587C27.9999 19.2353 27.8877 19.0542 27.7493 19.0542H19.2506C19.1122 19.0542 19 19.2353 19 19.4587Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.71429,
    cy: 21.7143,
    r: 7.71429,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49414 25.9965C6.78929 25.9718 7.05931 25.8206 7.23449 25.5818L11.4892 19.7815C11.8236 19.3257 11.7251 18.6851 11.2692 18.3507C10.8134 18.0163 10.1728 18.1148 9.83837 18.5706L6.27952 23.4223L4.7374 21.9223C4.33215 21.5281 3.68406 21.537 3.28987 21.9423C2.89568 22.3476 2.90465 22.9956 3.30991 23.3898L5.69534 25.7101C5.90765 25.9166 6.19899 26.0211 6.49414 25.9965Z",
    fill: "#06CEA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationTelexPositive);
export default __webpack_public_path__ + "static/media/notification-telex-positive.d8fab2b4c303ceb17186535c085e0d62.svg";
export { ForwardRef as ReactComponent };